import moment from "moment";
import Status from "@/domainObjects/Status";
import Plant from "@/domainObjects/Plant";
import Discrepancy from "@/domainObjects/wip/Discrepancy";
import WipQiDetails from "@/domainObjects/wip/WipQiDetails";
import WipActionItems from "@/domainObjects/wip/WipActionItems";

export default class WipTicket {

    wipTicketId: number;
    status: Status;
    discrepancy: Discrepancy;
    missingPartNumber: string;
    missingPartQty: number;
    plant: Plant;
    productionOrderNum: string;
    productionOrderQty: string;
    materialDesc: string;
    materialNum: string;
    onHoldDate: Date | string;
    prodDate: Date | string;
    shiftProduced: string;
    onHoldBy: string;
    salesOrderNum: string;
    color: string;
    optionNumber: string;
    lineItem: string;
    comments: string;
    qtyOnHold: number;
    stacksOnHold: number;
    stackNumOnHold: string;
    workCenter: string;

    closedBy: string;
    closedDate: Date | number;

    wipActionItems: WipActionItems[];
    qiHoldDetails: WipQiDetails[];
    //attachments: Attachments[];

    labor: number;
    loaded: boolean;
    disableEditMaterial: boolean;
    disableEditAll: boolean;

    // calculated
    daysOpen: number;

    constructor(){
        this.wipTicketId = 0;
        this.status = new Status();
        this.discrepancy = new Discrepancy();
        this.missingPartNumber = "";
        this.missingPartQty = 0;
        this.plant = new Plant();
        this.productionOrderNum = "";
        this.productionOrderQty = "";
        this.materialDesc = "";
        this.materialNum = "";
        this.onHoldDate = new Date();
        this.prodDate = new Date();
        this.shiftProduced = "";
        this.onHoldBy = "";
        this.salesOrderNum = "";
        this.color = "";
        this.optionNumber = "";
        this.lineItem = "";
        this.comments = "";
        this.qtyOnHold = 0;
        this.stacksOnHold = 0;
        this.stackNumOnHold = "";
        this.workCenter = "";

        this.closedBy = "";
        this.closedDate = new Date();

        this.wipActionItems = [new WipActionItems()];
        this.qiHoldDetails = [new WipQiDetails()];
        //this.attachments: [new Attachments()];

        this.labor = 0;
        this.loaded = false;
        this.disableEditMaterial = true;
        this.disableEditAll = false;
        // calculated
        this.daysOpen = 0;
    }

    initFromObject( wipTicket ) {
        this.wipTicketId = wipTicket.wipTicketId;
        this.status = wipTicket.status;
        this.discrepancy = wipTicket.discrepancy;
        this.missingPartQty = wipTicket.missingPartQty;
        this.missingPartNumber = wipTicket.missingPartNumber;
        this.plant = wipTicket.plant;
        this.productionOrderNum = wipTicket.productionOrderNum;
        this.productionOrderQty = wipTicket.productionOrderQty;
        this.materialDesc = wipTicket.materialDesc;
        this.materialNum = wipTicket.materialNum;
        this.onHoldDate = wipTicket.onHoldDate;
        this.prodDate = wipTicket.prodDate;
        this.shiftProduced = wipTicket.shiftProduced;
        this.onHoldBy = wipTicket.onHoldBy;
        this.salesOrderNum = wipTicket.salesOrderNum;
        this.color = wipTicket.color;
        this.optionNumber = wipTicket.optionNumber;
        this.lineItem = wipTicket.lineItem;
        this.comments = wipTicket.comments;
        this.qtyOnHold = wipTicket.qtyOnHold;
        this.stacksOnHold = wipTicket.stacksOnHold;
        this.stackNumOnHold = wipTicket.stackNumOnHold;
        this.workCenter = wipTicket.workCenter;

        this.closedBy = wipTicket.closedBy;
        this.closedDate = wipTicket.closedDate;

        this.wipActionItems = wipTicket.wipActionItems;
        this.qiHoldDetails = wipTicket.qiHoldDetails;
        //this.attachments = wipTicket.attachments;

        this.labor = wipTicket.labor;
        this.loaded = wipTicket.loaded;
        this.disableEditMaterial = true;
        this.disableEditAll = false;
        this.daysOpen = this.calculateDaysOpen(wipTicket.onHoldDate);
    }


    calculateDaysOpen(openDate): number {
        if (openDate) {
            let end;
            if (this.closedDate) {
                end = new Date(this.closedDate).toISOString().split('T');
            } else {
                end = new Date().toISOString().split('T');
            }
            let start = new Date(openDate).toISOString().split('T');
            let momentEnd = moment(end[0], 'YYYY-MM-DD');
            let momentStart = moment(start[0], 'YYYY-MM-DD');
            return Math.abs(momentStart.diff(momentEnd, "days"));
        } else {
            return -1;
        }
    }

    getQtyBalanceByLocation(location): number {
        let totalActionItemQty = 0;
        let totalQiHold = 0;

        //First - get the full quantity from the initial creation
        for (let j=0; j < this.qiHoldDetails.length; j++) {
            //WipQiHoldDetail detail = (WipQiHoldDetail)qiHoldDetails.get(j);
            if (this.qiHoldDetails[j].location != null && this.qiHoldDetails[j].location.toLowerCase() === location.toLowerCase()) {
                totalQiHold = this.qiHoldDetails[j].quantity;
            }
        }

        //Next, we need to add all action line items for that location
        for (let i=0; i < this.wipActionItems.length; i++) {
            //WipActionItem item = (WipActionItem)wipActionItems.get(i);
            if (this.wipActionItems[i].location != null && this.wipActionItems[i].location.toLowerCase() === location.toLowerCase()) {
                totalActionItemQty += this.wipActionItems[i].quantity;
            }
        }
        return totalQiHold - totalActionItemQty;
    }

    toJSON() {
        return {
            wipTicketId: this.wipTicketId,
            status: this.status,
            discrepancy: this.discrepancy,
            missingPartNumber: this.missingPartNumber,
            missingPartQty: this.missingPartQty,
            plant: this.plant,
            productionOrderNum: this.productionOrderNum,
            productionOrderQty: this.productionOrderQty,
            materialDesc: this.materialDesc,
            materialNum: this.materialNum,
            onHoldDate: this.onHoldDate,
            prodDate:this.prodDate,
            shiftProduced: this.shiftProduced,
            onHoldBy: this.onHoldBy,
            salesOrderNum: this.salesOrderNum,
            color: this.color,
            optionNumber: this.optionNumber,
            lineItem: this.lineItem,
            comments: this.comments,
            qtyOnHold: this.qtyOnHold,
            stacksOnHold: this.stacksOnHold,
            stackNumOnHold: this.stackNumOnHold,
            workCenter: this.workCenter,

            closedBy: this.closedBy,
            closedDate:this.closedDate,

            wipActionItems: this.wipActionItems,
            qiHoldDetails: this.qiHoldDetails,
            //attachments: this.attachments,

            labor: this.labor,
            loaded: this.loaded,
        }
    }

}


